// パスワードリセット
import ResetPassword from "@/pages/resetPassword/ResetPassword";

// パスワードリセット受付
import AcceptResetPassword from "@/pages/resetPassword/AcceptResetPassword";

// パスワード変更
import ResettingPassword from "@/pages/resetPassword/ResettingPassword";

// パスワードリセット完了
import DoneResetPassword from "@/pages/resetPassword/DoneResetPassword";

export default [
  {
    // パスワードリセット
    path: "/reset_password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      title: 'パスワードリセット - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      description: 'パスワードリセットはこちらから。 - desknet\'s NEO・ChatLuck（クラウド版）のサポートサイトです。当サイトでは、お客様情報・ご契約数・オプションサービス・お支払い方法のご確認・ご変更が可能です。',
    },
    props: true
  },
  {
    // パスワードリセット受付
    path: "/accept_reset_password",
    name: "AcceptResetPassword",
    component: AcceptResetPassword,
    meta: {
      title: 'パスワードリセット - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  },
  {
    // パスワード変更
    path: "/resetting_password",
    name: "ResettingPassword",
    component: ResettingPassword,
    meta: {
      title: 'パスワードリセット - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  },
  {
    // パスワードリセット完了
    path: "/done_reset_password",
    name: "DoneResetPassword",
    component: DoneResetPassword,
    meta: {
      title: 'パスワードリセット - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  }
]
